var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-height"},[_c('iframe',{attrs:{"src":_vm.urlFrontVida,"allow":"clipboard-read; clipboard-write"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }